import { Component, OnInit } from '@angular/core';
import { FilesProvider, ImageReadyService } from './providers/';
import { FileClass } from './file.class';
import { FileViewBase } from './file.view.directive';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'environments/environment';
@Component({
  selector: 'file-view-pdf',
  template: `
    <iframe [src]="url" width="100%" height="100%"></iframe>
  `
})
export class FileViewPdfComponent extends FileViewBase implements OnInit {
  constructor(public fp: FilesProvider, public irs: ImageReadyService, private san: DomSanitizer) {
    super(fp, irs);
    this.irs.done();
  }
  public url: SafeResourceUrl;

  ngOnInit() {
    this.url = this.file.view(this.san);
  }
}



// WEBPACK FOOTER //
// ./src/app/file.view.pdf.component.ts